// KAN-9620: no-op on web. Native iOS UI init lives in the Expo workspace (KAN-9592).
export async function initNativeUI(): Promise<void> {
  return;
}
